import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { DollarSign } from "lucide-react";
import { NuevoMovimiento } from "./NuevoMovimiento";
import { MovimientosListado } from "./MovimientosListado";
import { MovimientoCaja } from "@/lib/api";

// Alias for compatibility or easy refactoring
export type Movimiento = MovimientoCaja;

interface MovimientosSectionProps {
  movimientos?: Movimiento[];
  onMovimientosUpdate?: () => void; // Changed signature to void, as fetch is handled by parent
  cierres?: any[];
  onSensitiveStateChange?: (isSensitive: boolean) => void;
  isReadOnly?: boolean;
}

export function MovimientosSection({
  movimientos: propMovimientos,
  onMovimientosUpdate,
  cierres = [],
  onSensitiveStateChange,
  isReadOnly = false,
}: MovimientosSectionProps) {
  const [showNuevoMovimiento, setShowNuevoMovimiento] = useState(false);
  const [movimientos, setMovimientos] = useState<Movimiento[]>(propMovimientos || []);

  // Sync with prop changes
  React.useEffect(() => {
    if (propMovimientos) {
      setMovimientos(propMovimientos); // propMovimientos now comes from API
    }
  }, [propMovimientos]);

  React.useEffect(() => {
    onSensitiveStateChange?.(showNuevoMovimiento);
    return () => onSensitiveStateChange?.(false);
  }, [showNuevoMovimiento, onSensitiveStateChange]);

  const handleCreateMovimiento = (_movimiento: Movimiento) => { // This receives the optimistic or created object
    // With API, parent handles refresh.
    // We can just close the form.
    setShowNuevoMovimiento(false);
    if (onMovimientosUpdate) {
      onMovimientosUpdate();
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center shadow-md">
            <DollarSign className="h-5 w-5 text-white" />
          </div>
          <h3 className="text-2xl font-bold">Movimientos</h3>
        </div>
        {!isReadOnly && (
          <Button
            variant="default"
            size="sm"
            onClick={() => setShowNuevoMovimiento(!showNuevoMovimiento)}
            className="flex items-center gap-1"
          >
            <DollarSign className="h-4 w-4" />
            <span className="text-xs">
              {showNuevoMovimiento ? "Ver Listado" : "Nuevo Movimiento"}
            </span>
          </Button>
        )}
      </div>

      {showNuevoMovimiento && !isReadOnly ? (
        <NuevoMovimiento
          onBack={() => setShowNuevoMovimiento(false)}
          onCreate={handleCreateMovimiento}
          cierres={cierres}
        />
      ) : (
        <MovimientosListado
          movimientos={movimientos}
          isReadOnly={isReadOnly}
          onDeleted={onMovimientosUpdate}
        />
      )}
    </div>
  );
}